import type { ReactNode } from 'react';
import LoadingFallback from './LoadingFallback';

/** 保留页面主体的文档流高度，同时沿用原有全屏加载遮罩和交互门禁。 */
export default function PageLoadingFallback({ children }: { children?: ReactNode }) {
  return (
    <div className="min-h-screen">
      {children}
      <LoadingFallback />
    </div>
  );
}
